export default __webpack_public_path__ + "static/media/ford.ccf3c80c.svg";